<template>
  <img v-if="src"
       :src="processedSrc"
       :width="width"
       :height="height"
       @error="handleError">
</template>
<script>
import { processedUrl } from '@padlet/vivaldi-client'

export default {
  props: ['transforms', 'src', 'width', 'height'],
  computed: {
    processedSrc () {
      // For relative urls in development
      if (this.src.startsWith('/')) return this.src

      const purl = processedUrl(this.src, this.transforms)
      return purl
    },
  },
  methods: {
    handleError (error) {
      this.$emit('error', error)
    },
  },
}
</script>
